import React, { useEffect } from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import Helmet from "react-helmet";
import Layout from "../../templates/Layout/layout";
import Header from "../../templates/TransparentHeader/index";
import HeadingSection from "./sections/heading-section";
import BreadcrumbSection from "./sections/breadcrumb-section";
import ContentSection from "./sections/content-section";
import RelatedContent from "./sections/related-content";
import Footer from "../../templates/Footer/index";
import ShareIcons from "./sections/share-icons";
import TrackUtms from "../../../helpers/utmTracking";
import TableOfContents from "./sections/table-of-contents";
import HeaderImage from "./sections/header-image";

const ContentContainer = styled.div`
	margin: auto;
	position: relative;
	max-width: 1200px;
	margin: auto;
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	max-width: 1200px;
	margin: auto;
	margin-top: 27px;
	margin-bottom: 116px;

  @media (max-width: 1200px) {
    padding: 0 20px;
  }
`;

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
  width: 863px;

	@media screen and (max-width: 1200px) {
		width: 70%;
	}

	@media screen and (max-width: 769px) {
    width: 100%;
	}
`;

const HeaderProperties = ({ data }) => {
	const defaultTitle = data.title;
	const defaultDescription =
		"Employees want to be recognized, but that's not enough these days. They want to be engaged and heard too. Motivosity allows team members to reward each other and helps your managers be better leaders. Help your team be happier at work!";
	const imagePath =
		data.blogHeroImage.childImageSharp.gatsbyImageData.images.fallback.src;

	return (
		<Helmet>
			<title>{data.seoTitle ? data.seoTitle : defaultTitle}</title>
			<meta
				name="description"
				content={data.description ? data.description : defaultDescription}
			/>
			<meta
				property="og:url"
				content={"https://www.motivosity.com/blog" + data.path + "/"}
			/>

			<meta property="fb:app_id" content="1448220805478189" />
			<meta
				property="og:image"
				content={"https://www.motivosity.com" + imagePath}
			/>
			<meta property="og:image:height" content="500" />
			<meta property="og:image:width" content="500" />
			<meta property="og:image:alt" content={"Image for " + data.seoTitle} />
			<meta
				property="og:title"
				content={data.seoTitle ? data.seoTitle : defaultTitle}
			/>
			<meta
				property="og:description"
				content={data.description ? data.description : defaultDescription}
			/>
			<meta name="format-detection" content="telephone=no" />
			<link
				rel="canonical"
				href={"https://www.motivosity.com/blog" + data.path + "/"}
			/>
		</Helmet>
	);
};

export default function BlogTemplate({ data }) {
	useEffect(() => {
		TrackUtms();
	}, []);
	const pageData = data.markdownRemark.frontmatter;

	return (
		<>
			<Layout>
				<HeaderProperties data={pageData} />
				<Header />
				<HeaderImage
					image={pageData.blogHeroImage}
					imageAlt={pageData.blogHeroImageAlt}
				/>

				<ContentContainer>
					<ContentWrapper>
						<BreadcrumbSection title={pageData.title} />

						<HeadingSection
							title={pageData.title}
							by={pageData.by}
							date={pageData.date}
						/>
						<ShareIcons url={pageData.path} title={pageData.title} />
						<ContentSection
							url={pageData.path}
							title={pageData.title}
							paragraphs={pageData.paragraphs}
							authorImage={pageData.authorImage}
							authorDescription={pageData.authorDescription}
							authorImageAlt={pageData.authorImageAlt}
							authorLink={pageData.authorLink}
							fullWidth={!(pageData.smallAd || pageData.relatedResources)}
						/>
					</ContentWrapper>
					<TableOfContents />
				</ContentContainer>
				<RelatedContent relatedContent={pageData.relatedContent} />
				<Footer />
			</Layout>
		</>
	);
}

export const query = graphql`
	query Blog($slug: String!) {
		markdownRemark(fields: { slug: { eq: $slug } }) {
			html
			frontmatter {
				path
				description
				seoTitle
				title
				description
				date
				by
				blogHeroImage {
					childImageSharp {
						gatsbyImageData(placeholder: NONE, quality: 100)
					}
				}
				blogHeroImageAlt
				paragraphs {
					paragraphObj {
						paragraph
						paragraphTitle
						paragraphSubTitle
						paragraphH4
						blogImage {
							childImageSharp {
								gatsbyImageData(placeholder: NONE, quality: 100)
							}
						}
						floatImage
						blogImageAlt
						blogImageLink
						bulletList
						orderedList
					}
				}
				authorImage {
					childImageSharp {
						gatsbyImageData(placeholder: NONE)
					}
				}
				authorDescription
				authorImageAlt
				authorLink
				relatedContent {
					type
					title
					image {
						childImageSharp {
							gatsbyImageData(width: 225, height: 150, placeholder: NONE)
						}
					}
					imageAlt
					link
				}
			}
		}
	}
`;
